export enum MessagingVerificationStatus {
  None = "None",
  Pending = "PENDING",
  Approved = "APPROVED",
  Rejected = "REJECTED",
  Error = "ERROR",
  Verified = "VERIFIED",
  Failed = "FAILED",
}

export enum MessageTypes {
  SMS = "SMS",
  WhatsApp = "WhatsApp",
  Web = "Web",
}
